module.exports = __webpack_public_path__ + "static/img/enterprise_img_1_cn.0ede713.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_svg/enterprise_img_1_cn.png
// module id = FwgB
// module chunks = 0